/**
 * Page priority list for determining default landing pages.
 * Order matters — the first page the user has permission for wins.
 */
const PAGE_PRIORITY = [
  { path: "/dashboard", mobilePath: "/m", permission: "page.dashboard" },
  { path: "/ni/dashboard", permission: "page.ni_dashboard" },
  { path: "/migration/dashboard", permission: "page.migration_dashboard" },
  { path: "/migration/dispatch-dashboard", permission: "page.migration_dashboard" },
  { path: "/migration/uploaded", permission: "migration.view_uploaded" },
  { path: "/migration/for-calling", permission: "migration.view_calling" },
  { path: "/migration/for-dispatch", permission: "migration.view_dispatch" },
  { path: "/migration/visited-called", permission: "migration.view_visited" },
  { path: "/reports/fst-daily-output", permission: "reports.fst_daily_output" },
  { path: "/reports", permission: "page.reports" },
  { path: "/xlsx-imports", permission: "page.xlsx_imports", altPermission: "xlsx.view" },
  { path: "/manage-accounts", permission: "page.manage_accounts" },
  { path: "/roles", permission: "roles.view" },
  { path: "/team-leaders", permission: "page.team_leaders" },
  { path: "/teams", permission: "page.teams" },
  { path: "/companies", permission: "page.companies" },
  { path: "/nap-locator", permission: "page.nap_locator" },
  { path: "/database-backups", permission: "page.database_backups" },
  { path: "/login-activity", permission: "sessions.view" },
];

/**
 * Given a Set (or array) of permission keys, return the path of the first
 * page the user is allowed to access. Returns null when no page is permitted.
 *
 * @param {Set|string[]} permissions
 * @param {{ isMobile?: boolean }} options
 */
export function getFirstAllowedPage(permissions, { isMobile = false } = {}) {
  const perms = permissions instanceof Set ? permissions : new Set(permissions || []);
  for (const page of PAGE_PRIORITY) {
    if (perms.has(page.permission) || (page.altPermission && perms.has(page.altPermission))) {
      return isMobile && page.mobilePath ? page.mobilePath : page.path;
    }
  }
  return null;
}
